"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = whileConnectedEffect;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _connect = require("../../actions/connect");

var _disconnect = require("../../actions/disconnect");

var _reconnect = require("../../actions/reconnect");

function whileConnectedEffect(fn) {
  return (0, _effects.call)( /*#__PURE__*/_regenerator["default"].mark(function whileConnected() {
    var _yield$take, _yield$take$meta, userID, username, directLine, task;

    return _regenerator["default"].wrap(function whileConnected$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _effects.take)([_connect.CONNECT_FULFILLING, _reconnect.RECONNECT_FULFILLING]);

          case 2:
            _yield$take = _context.sent;
            _yield$take$meta = _yield$take.meta;
            userID = _yield$take$meta.userID;
            username = _yield$take$meta.username;
            directLine = _yield$take.payload.directLine;
            _context.next = 9;
            return (0, _effects.fork)(fn, {
              directLine: directLine,
              userID: userID,
              username: username
            });

          case 9:
            task = _context.sent;
            _context.next = 12;
            return (0, _effects.take)([_disconnect.DISCONNECT_PENDING, _reconnect.RECONNECT_PENDING]);

          case 12:
            _context.next = 14;
            return (0, _effects.cancel)(task);

          case 14:
            _context.next = 0;
            break;

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, whileConnected);
  }));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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